import { editorContentShiftViewState } from "../..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateFullDayInfoCalloutVisible", function updateFullDayInfoCalloutVisible(isVisible: boolean) {
    editorContentShiftViewState().fullDayInfoCalloutVisible = isVisible;
});
